enum AppStatus {
  Blank = "", //added blank state to avoid random down/maintenance page when logging out of app
  OK = "OK",
  NotOK = "Not OK"
}
export default AppStatus;
